import type { FaireProductEntity } from "../../entity_types/product";

export const p_jd3k3c33c7: FaireProductEntity = {
  token: "p_jd3k3c33c7",
  type: "product",
  name: "Striped Wool Triangle Scarf for Women - Soft and Cozy",
  brandToken: "b_5qb9p6vh8d",
  brandName: "SALINA TRADING INC",
  imageUrl:
    "https://cdn.faire.com/fastly/205e3fd8c9b691ec80f35b92f6ef4066a7112ae1c0ec1468cc3f773e3105ae34.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9702e106c627d98d654093e6fcb2c41d22a79c5c6c258620ddd98b0c09f83467.jpeg",
    "https://cdn.faire.com/fastly/c907b6ba927004b3da6770288625beab56e9e01999578a6bb81617492b5cc1fa.jpeg",
    "https://cdn.faire.com/fastly/58a4fec1d674c5c5347e8045a4abb09e854dda704570a0910cbe760dc23b8115.jpeg",
    "https://cdn.faire.com/fastly/9d47bb6a749c76542c610c71c0bce3fab672463a9bc4fdd102fca177aedb41d4.jpeg",
    "https://cdn.faire.com/fastly/13c15b458cd400bc3c78ca4138c5681d35cdafc35c41ac32442b6658b9aa529a.jpeg",
    "https://cdn.faire.com/fastly/ac1fd6fb46cb97fc34afd38408bc8fedaef3bc7dbb769037131c148d37602a28.jpeg",
    "https://cdn.faire.com/fastly/a1527e25850488e6c8e8e741aad8ae223e4b13a7150bda07beb644a3f36ec0d3.jpeg",
    "https://cdn.faire.com/fastly/420cc19bc4c3ff471ba4cd395673d02160028a6c55418af3bfe3a126c7517e97.jpeg",
  ],
  priceDollars: 9.75,
  description:
    'This handcrafted triangular scarf is perfect for adding warmth and style to your winter outfits. Made from high-quality wool, it features a unique striped design that effortlessly enhances your look. This versatile accessory can be worn in multiple ways, providing both comfort and flair.\nFeatures: \n * Material: 100% Wool \n * Dimensions: 43.3" x 15.7" (110 x 40 cm) \n * Color Options: Black and White, Red and White, Green and Brown, Dark Gray \n * Style: Casual and Trendy \nThis scarf not only provides warmth but also adds a chic touch to any outfit. Ideal for all occasions, it’s a must-have accessory for your winter wardrobe.\n',
  tags: [],
  msrpDollars: 19.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:43.655Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
